import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ro';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

export function now() {
    return dayjs();
}

export function momentFromDate(str?: string | Date | dayjs.Dayjs, format?: string) {
    return dayjs(str, format);
}

export function momentFromDateTZ(str: string | Date, timezone: string) {
    return dayjs.tz(str, timezone);
}

export function momentLocale(locale: string) {
    return dayjs.locale(locale);
}

export function momentUtc() {
    return dayjs.utc();
}

export function momentExpired(str: string | Date, value?: number, unit?: dayjs.ManipulateType) {
    if (!str || !dayjs(str).isValid()) {
        return true;
    }

    if (!value || !unit) {
        return dayjs(str).isBefore(dayjs());
    }

    return dayjs(str).add(value, unit).isBefore(dayjs());
}
